<div class="order-template-container bg-white rounded-3 p-4">
  <!-- Top header row with search and create button -->
  <div class="template-header-row d-flex flex-wrap align-items-center justify-content-between gap-3 mb-3">
    <div class="search-box-wrapper flex-grow-1">
      <div class="input-group search-input-group align-items-center">
        <i class="ri-search-line search-icon"></i>
        <input
          type="text"
          class="form-control border-0 bg-transparent search-input ps-2"
          placeholder="Tìm kiếm đơn hàng thường xuyên"
          [(ngModel)]="searchTerm"
          (input)="onSearchInput()"
        />
        <button
          *ngIf="searchTerm"
          class="btn-clear-search border-0 bg-transparent pe-3"
          type="button"
          (click)="searchTerm = ''; onSearchInput()"
        >
          <i class="ri-close-line text-muted"></i>
        </button>
      </div>
    </div>

    <button class="btn btn-theme-create" type="button" (click)="openCreateModal()">
      + Tạo đơn hàng thường xuyên mới
    </button>
  </div>

  <!-- Loading skeleton -->
  <div *ngIf="loading" class="template-loading-wrapper py-4">
    <div class="template-card-skeleton mb-3" *ngFor="let i of [1, 2, 3]">
      <div class="skeleton-line w-50 mb-2"></div>
      <div class="skeleton-line w-25"></div>
    </div>
  </div>

  <!-- Empty State (Screen 1 in Figma) -->
  <div
    class="empty-state-section text-center py-5"
    *ngIf="!loading && templates.length === 0"
  >
    <div class="empty-image-wrap mb-4">
      <img
        src="assets/svg/order-template-empty.svg"
        alt="Chưa có đơn hàng thường xuyên"
        class="empty-image img-fluid"
      />
    </div>
    <p class="empty-guide-text mx-auto mb-4">
      Đơn hàng thường xuyên là đơn hàng được đặt định kỳ với số lượng và chủng loại không thay đổi. Bạn có thể lưu đơn hàng thường xuyên để đặt lại nhanh hơn mà không cần mất thời gian để tạo đơn hàng mới.
    </p>
    <button class="btn btn-theme-create mx-auto" type="button" (click)="openCreateModal()">
      + Tạo đơn hàng thường xuyên mới
    </button>
  </div>

  <!-- List View (Screen 2 in Figma) -->
  <div class="template-list-wrapper" *ngIf="!loading && templates.length > 0">
    <div
      class="template-row-card d-flex align-items-center justify-content-between p-3 mb-3"
      *ngFor="let item of templates"
    >
      <!-- Left: Name & Last used text -->
      <div class="template-col-left flex-grow-1 me-2 overflow-hidden">
        <h5 class="template-card-title text-truncate mb-1" (click)="openDetail(item)" [title]="item.name">
          {{ item.name }}
        </h5>
        <div class="template-card-subtitle text-muted">
          {{ item.lastUsedText || 'Chưa đặt' }}
        </div>
      </div>

      <!-- Middle: Product counts (ẩn trên mobile) -->
      <div class="template-col-mid me-3 d-none d-md-block">
        <div class="template-counts-text text-muted text-nowrap">
          SP: {{ item.itemCount }} &nbsp; SL: {{ item.totalQuantity }}
        </div>
      </div>

      <!-- Right: Action Buttons -->
      <div class="template-col-actions d-flex align-items-center gap-2 flex-shrink-0">
        <!-- Desktop: full text buttons -->
        <button
          class="btn btn-outline-detail d-none d-md-inline-flex"
          type="button"
          (click)="openDetail(item)"
        >
          Xem chi tiết
        </button>
        <!-- Mobile: icon-only detail button -->
        <button
          class="btn btn-outline-detail btn-icon-only d-inline-flex d-md-none"
          type="button"
          title="Xem chi tiết"
          (click)="openDetail(item)"
        >
          <i class="ri-eye-line"></i>
        </button>

        <button
          class="btn btn-theme-place-order"
          type="button"
          [disabled]="isAddingToCart[item.id]"
          (click)="onAddToCart(item, $event)"
        >
          <span
            *ngIf="isAddingToCart[item.id]"
            class="spinner-border spinner-border-sm"
            role="status"
          ></span>
          <span *ngIf="!isAddingToCart[item.id]" class="d-none d-md-inline">Đặt đơn</span>
          <i *ngIf="!isAddingToCart[item.id]" class="ri-shopping-cart-line d-inline d-md-none"></i>
          <span *ngIf="!isAddingToCart[item.id]" class="d-inline d-md-none ms-1">Đặt</span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- ========================================================================= -->
<!-- DETAIL & EDIT MODAL (Screen 1 & 4 in Figma)                               -->
<!-- ========================================================================= -->
<ng-template #detailModal let-modal>
  <div class="order-template-detail-modal-card" *ngIf="selectedTemplate">
    <!-- ------------------------------------------------------------- -->
    <!-- 1. DETAIL MODE (Screen 4 in Figma)                           -->
    <!-- ------------------------------------------------------------- -->
    <ng-container *ngIf="!isEditMode">
      <!-- Header -->
      <div class="modal-header-section d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
        <h5 class="modal-header-title m-0 text-truncate pe-3 fw-bold" [title]="selectedTemplate.name">
          {{ selectedTemplate.name }}
        </h5>
        <div class="modal-header-actions d-flex align-items-center gap-3">
          <!-- Red trash bin delete template button -->
          <button
            class="btn-icon-danger"
            type="button"
            title="Xóa đơn hàng thường xuyên"
            (click)="onDeleteClick(selectedTemplate)"
          >
            <i class="ri-delete-bin-line"></i>
          </button>
          <!-- Close icon -->
          <button
            class="btn-icon-close"
            type="button"
            title="Đóng"
            (click)="closeDetail()"
          >
            <i class="ri-close-line"></i>
          </button>
        </div>
      </div>

      <!-- Body / Products list -->
      <div class="modal-body-section overflow-auto p-3 p-md-4 custom-scrollbar">
        <div *ngIf="detailLoading" class="text-center py-5">
          <div class="spinner-border text-success" role="status"></div>
          <div class="mt-2 text-muted">Đang tải sản phẩm...</div>
        </div>

        <div *ngIf="!detailLoading && (!selectedTemplate.items || selectedTemplate.items.length === 0)" class="text-center py-5 text-muted">
          Chưa có sản phẩm nào trong đơn hàng mẫu này.
        </div>

        <div
          class="product-row-item d-flex align-items-center py-3 border-bottom"
          *ngFor="let prod of selectedTemplate.items; let idx = index"
        >
          <!-- Number index -->
          <div class="item-index-col me-3 text-muted fw-bold">
            {{ idx + 1 }}
          </div>

          <!-- Thumbnail Image -->
          <div class="item-img-col me-3 flex-shrink-0">
            <img
              [src]="prod.availability && prod.availability !== 'Available' ? unavailableProductImage : (prod.imageUrl || unavailableProductImage)"
              [alt]="prod.productName || prod.sku"
              class="item-thumb-img rounded"
              (error)="prod.imageUrl = unavailableProductImage"
            />
          </div>

          <!-- Product Name & Price -->
          <div class="item-info-col flex-grow-1 me-3">
            <div class="item-name fw-medium mb-1 line-clamp-2" [title]="prod.productName || prod.sku">
              {{ prod.productName || prod.sku }}
            </div>

            <div class="item-price-row d-flex align-items-center flex-wrap gap-2">
              <span class="display-price fw-bold" *ngIf="prod.displayPrice">
                {{ prod.displayPrice | currencySymbol }}
              </span>
              <span
                class="strike-price text-muted text-decoration-line-through small"
                *ngIf="prod.basePrice && prod.displayPrice && prod.basePrice > prod.displayPrice"
              >
                {{ prod.basePrice | currencySymbol }}
              </span>
              <span
                class="discount-tag small fw-bold"
                *ngIf="prod.basePrice && prod.displayPrice && prod.basePrice > prod.displayPrice"
              >
                -{{ getDiscountPercent(prod.basePrice, prod.displayPrice) }}%
              </span>
              <span class="text-muted small" *ngIf="!prod.displayPrice">
                Chưa có giá
              </span>
            </div>

            <!-- Availability warnings if not available -->
            <div
              class="item-warning-badge badge bg-warning text-dark mt-1"
              *ngIf="prod.availability && prod.availability !== 'Available'"
            >
              {{ getAvailabilityText(prod.availability) }}
            </div>
          </div>

          <!-- Right: Quantity -->
          <div class="item-qty-col flex-shrink-0 text-end fw-medium text-nowrap">
            <span class="d-none d-md-inline">Số lượng: </span>
            <span>{{ prod.quantity }}</span>
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="modal-footer-section p-3 p-md-4 border-top bg-white">
        <div class="subtotal-row d-flex align-items-center justify-content-between mb-3" *ngIf="selectedTemplate.estimatedSubtotal">
          <span class="subtotal-label fw-medium text-dark">Giá trị tạm tính</span>
          <span class="subtotal-value fw-bold text-danger fs-5">
            {{ (selectedTemplate.estimatedSubtotal || 0) | currencySymbol }}
          </span>
        </div>

        <div class="footer-actions-row d-flex align-items-center gap-2 mb-2">
          <button
            class="btn btn-pill-gray flex-grow-1 d-flex align-items-center justify-content-center"
            type="button"
            (click)="enterEditMode()"
            [disabled]="detailLoading || !detailReady"
          >
            <i class="ri-edit-line me-1 me-md-2"></i>
            <span class="d-none d-md-inline">Thay đổi sản phẩm / </span>Số lượng
          </button>

          <button
            class="btn btn-pill-green flex-grow-1 d-flex align-items-center justify-content-center"
            type="button"
            [disabled]="isAddingToCart[selectedTemplate.id]"
            (click)="onAddToCart(selectedTemplate)"
          >
            <span
              *ngIf="isAddingToCart[selectedTemplate.id]"
              class="spinner-border spinner-border-sm me-1 me-md-2"
              role="status"
            ></span>
            <i *ngIf="!isAddingToCart[selectedTemplate.id]" class="ri-shopping-cart-line me-1 me-md-2"></i>
            <span class="d-none d-md-inline">Thêm vào giỏ hàng</span>
            <span class="d-inline d-md-none">Đặt đơn</span>
          </button>
        </div>

        <p class="modal-disclaimer-text text-muted small m-0 text-center d-none d-md-block">
          Giá sản phẩm là giá tạm tính và chưa bao gồm voucher và giảm giá của GiaThuocTot.Com. Thêm vào giỏ hàng để xem giá trị cuối cùng của đơn hàng.
        </p>
      </div>
    </ng-container>

    <!-- ------------------------------------------------------------- -->
    <!-- 2. EDIT MODE (Screen 1 & 2 in Figma)                         -->
    <!-- ------------------------------------------------------------- -->
    <ng-container *ngIf="isEditMode">
      <fieldset class="border-0 p-0 m-0" [disabled]="isSavingChanges" style="min-width: 0;">
      <!-- Header -->
      <div class="modal-header-section d-flex align-items-center justify-content-between px-4 py-3 border-bottom">
        <div class="d-flex align-items-center flex-grow-1 me-2 overflow-hidden">
          <button
            class="btn-back me-2 border-0 bg-transparent p-0"
            type="button"
            (click)="cancelEditMode()"
            title="Quay lại"
          >
            <i class="ri-arrow-left-s-line fs-4"></i>
          </button>

          <!-- Template name -->
          <div class="flex-grow-1 overflow-hidden">
            <h5 class="modal-header-title m-0 text-truncate fw-bold" [title]="editTemplateName">
              {{ editTemplateName }}
            </h5>
          </div>
        </div>

        <!-- Rename button (Green link) -->
        <button
          class="btn-rename text-nowrap"
          type="button"
          (click)="openRenameModal()"
        >
          Đổi tên
        </button>
      </div>

      <!-- Search bar (Screen 1 in Figma) -->
      <div class="edit-search-bar-wrap px-4 py-3 border-bottom">
        <div class="input-group search-input-group align-items-center">
          <i class="ri-search-line search-icon"></i>
          <input
            type="text"
            class="form-control border-0 bg-transparent search-input ps-2"
            placeholder="Tìm kiếm sản phẩm"
            [(ngModel)]="editSearchTerm"
          />
          <button
            *ngIf="editSearchTerm"
            class="btn-clear-search border-0 bg-transparent pe-2"
            type="button"
            (click)="editSearchTerm = ''"
          >
            <i class="ri-close-line text-muted"></i>
          </button>
        </div>
      </div>

      <!-- Products list in edit mode -->
      <div class="modal-body-section overflow-auto p-4 custom-scrollbar">
        <div class="create-search-section edit-add-product-section mb-4">
          <label for="template-add-product-search" class="form-label fw-semibold text-dark mb-2">
            Tìm kiếm & thêm sản phẩm
          </label>
          <div class="create-search-bar-wrapper position-relative">
            <div class="create-search-bar position-relative">
              <i class="ri-search-line search-icon position-absolute"></i>
              <input id="template-add-product-search" type="text" class="form-control create-search-input"
                placeholder="Nhập tên thuốc, hoạt chất hoặc mã SKU để tìm kiếm..."
                [disabled]="isSavingChanges"
                [(ngModel)]="addProductSearchTerm" (input)="onAddProductSearchInput()" />
              <button *ngIf="addProductSearchTerm && !isSearchingAddProducts" type="button"
                class="btn-clear-search position-absolute" [disabled]="isSavingChanges"
                aria-label="Xóa tìm kiếm sản phẩm" (click)="addProductSearchTerm = ''; onAddProductSearchInput()">
                <i class="ri-close-circle-fill"></i>
              </button>
              <span *ngIf="isSearchingAddProducts" role="status" aria-label="Đang tìm sản phẩm"
                class="search-spinner position-absolute spinner-border spinner-border-sm text-theme"></span>
            </div>
            <div *ngIf="addProductSearchError || (addProductSearchTerm.trim() && !isSearchingAddProducts)"
              class="create-search-results-box border rounded-3 mt-2">
              <div *ngIf="addProductSearchError" class="p-3 text-center text-danger small">
                Không thể tìm sản phẩm. Vui lòng thử lại.
              </div>
              <div *ngIf="!addProductSearchError && !addProductResults.length" class="p-3 text-center text-muted small">
                <i class="ri-information-line fs-5 d-block mb-1 text-secondary"></i>
                Không tìm thấy sản phẩm phù hợp với từ khóa <strong>"{{ addProductSearchTerm }}"</strong>.
              </div>
              <div *ngFor="let product of addProductResults; let idx = index" class="search-result-row p-2 border-bottom">
                <div class="result-summary d-flex align-items-center overflow-hidden">
                  <img [src]="product.imageUrls?.[0] || product.imageUrl || unavailableProductImage"
                    [alt]="product.name || product.sku || product.SKU" class="result-thumb me-2 rounded flex-shrink-0"
                    (error)="product.imageUrls = []; product.imageUrl = unavailableProductImage" />
                  <div class="result-info overflow-hidden">
                    <div class="result-name fw-medium text-dark text-truncate" [title]="product.name || product.sku || product.SKU">
                      {{ product.name || product.sku || product.SKU }}
                    </div>
                    <div class="result-meta small text-muted text-truncate">SKU: {{ product.sku || product.SKU }}</div>
                    <div class="result-price fw-bold text-danger small mt-1">
                      {{ (product.pricingTablePrice || product.basePrice || 0) | currencySymbol }}
                    </div>
                  </div>
                </div>
                <div class="result-actions d-flex align-items-center gap-2 flex-shrink-0">
                  <label [for]="'template-add-quantity-' + idx" class="small text-muted text-nowrap mb-0">SL thêm</label>
                  <input [id]="'template-add-quantity-' + idx" type="number" min="1" step="1"
                    class="form-control form-control-sm result-quantity" [disabled]="isSavingChanges"
                    [(ngModel)]="product.additionQuantity" />
                  <button type="button" class="btn btn-sm btn-add-product text-nowrap"
                    [disabled]="isSavingChanges || !product.additionQuantity || product.additionQuantity < 1"
                    (click)="addEditProduct(product)">
                    <i class="ri-add-line me-1"></i>Thêm
                  </button>
                </div>
              </div>
            </div>
          </div>
          <small class="text-muted d-block mt-2">Sản phẩm đã có sẽ được cộng thêm số lượng. Bấm Lưu thay đổi để lưu vào đơn hàng mẫu.</small>
        </div>
        <!-- Empty search results (Screen 2 in Figma) -->
        <div *ngIf="filteredEditItems.length === 0" class="empty-search-state text-center py-5">
          <div class="empty-search-icon-wrap mb-3">
            <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="58" cy="58" r="42" fill="#E8F5E9" opacity="0.6"/>
              <path d="M42 45C42 43.3431 43.3431 42 45 42H75C76.6569 42 78 43.3431 78 45V75C78 76.6569 76.6569 78 75 78H45C43.3431 78 42 76.6569 42 75V45Z" fill="#C8E6C9" opacity="0.5"/>
              <circle cx="55" cy="55" r="22" stroke="#2E7D32" stroke-width="4" stroke-linecap="round" fill="none"/>
              <line x1="71" y1="71" x2="88" y2="88" stroke="#2E7D32" stroke-width="5" stroke-linecap="round"/>
              <circle cx="78" cy="40" r="4" fill="#81C784"/>
              <circle cx="36" cy="68" r="3" fill="#A5D6A7"/>
            </svg>
          </div>
          <div class="fw-bold text-dark fs-6 mb-1">Không tìm thấy sản phẩm.</div>
          <div class="text-muted small">Vui lòng kiểm tra lại hoặc tìm kiếm với từ khóa khác.</div>
        </div>

        <div
          class="product-row-item edit-item-row d-flex align-items-center py-3 border-bottom"
          *ngFor="let prod of filteredEditItems; let idx = index"
        >
          <!-- Thumbnail Image -->
          <div class="item-img-col me-3 flex-shrink-0">
            <img
              [src]="prod.availability && prod.availability !== 'Available' ? unavailableProductImage : (prod.imageUrl || unavailableProductImage)"
              [alt]="prod.productName || prod.sku"
              class="item-thumb-img rounded"
              (error)="prod.imageUrl = unavailableProductImage"
            />
          </div>

          <!-- Product Name & Price -->
          <div class="item-info-col flex-grow-1 me-3">
            <div class="item-name fw-medium mb-1 line-clamp-2" [title]="prod.productName || prod.sku">
              {{ prod.productName || prod.sku }}
            </div>

            <div class="item-price-row d-flex align-items-center flex-wrap gap-2">
              <span class="display-price fw-bold" *ngIf="prod.displayPrice">
                {{ prod.displayPrice | currencySymbol }}
              </span>
              <span
                class="strike-price text-muted text-decoration-line-through small"
                *ngIf="prod.basePrice && prod.displayPrice && prod.basePrice > prod.displayPrice"
              >
                {{ prod.basePrice | currencySymbol }}
              </span>
              <span
                class="discount-tag small fw-bold"
                *ngIf="prod.basePrice && prod.displayPrice && prod.basePrice > prod.displayPrice"
              >
                -{{ getDiscountPercent(prod.basePrice, prod.displayPrice) }}%
              </span>
              <span class="text-muted small" *ngIf="!prod.displayPrice">
                Chưa có giá
              </span>
            </div>
          </div>

          <!-- Actions: Red Trash Icon + Quantity Stepper -->
          <div class="item-edit-actions d-flex align-items-center gap-2 flex-shrink-0">
            <!-- Trash button to remove from template -->
            <button
              class="btn-trash-item"
              type="button"
              title="Xóa khỏi đơn mẫu"
              (click)="removeItem(prod)"
            >
              <i class="ri-delete-bin-line"></i>
            </button>

            <!-- Stepper: [ - ] [ 5 ] [ + ] -->
            <div class="qty-stepper d-flex align-items-center">
              <button
                class="btn-stepper btn-minus"
                type="button"
                [disabled]="prod.quantity <= 1"
                (click)="changeQty(prod, -1)"
              >
                -
              </button>
              <input
                type="number"
                class="stepper-input"
                [(ngModel)]="prod.quantity"
                (change)="validateQty(prod)"
                min="1"
              />
              <button
                class="btn-stepper btn-plus"
                type="button"
                (click)="changeQty(prod, 1)"
              >
                +
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Edit Footer -->
      <div class="modal-footer-section p-4 border-top bg-white">
        <div class="subtotal-row d-flex align-items-center justify-content-between mb-3">
          <span class="subtotal-label fw-medium text-dark">Giá trị tạm tính</span>
          <span class="subtotal-value fw-bold text-danger fs-5">
            {{ getEditEstimatedSubtotal() | currencySymbol }}
          </span>
        </div>

        <div class="footer-actions-row d-flex align-items-center gap-3 mb-2">
          <!-- Cancel button (gray pill) -->
          <button
            class="btn btn-pill-gray flex-grow-1 d-flex align-items-center justify-content-center"
            type="button"
            (click)="cancelEditMode()"
          >
            <i class="ri-close-line me-1"></i>
            Hủy bỏ
          </button>

          <!-- Save changes button (green pill) -->
          <button
            class="btn btn-pill-green flex-grow-1 d-flex align-items-center justify-content-center"
            type="button"
            [disabled]="isSavingChanges || editItems.length === 0"
            (click)="saveChanges()"
          >
            <span
              *ngIf="isSavingChanges"
              class="spinner-border spinner-border-sm me-2"
              role="status"
            ></span>
            <i *ngIf="!isSavingChanges" class="ri-check-line me-1"></i>
            Lưu thay đổi
          </button>
        </div>

        <p class="modal-disclaimer-text text-muted small m-0 text-center">
          Giá sản phẩm là giá tạm tính và chưa bao gồm voucher và giảm giá của GiaThuocTot.Com. Giá trị cuối cùng của đơn hàng sẽ được tính sau khi bạn thêm sản phẩm vào giỏ hàng.
        </p>
      </div>
      </fieldset>
    </ng-container>
  </div>
</ng-template>

<!-- ========================================================================= -->
<!-- RENAME MINI MODAL (Screen 3 in Figma)                                     -->
<!-- ========================================================================= -->
<ng-template #renameModal let-modal>
  <div class="order-template-mini-card p-4">
    <h5 class="mini-modal-title text-center fw-bold mb-4">Đổi tên</h5>
    <div class="mb-4">
      <label class="form-label text-muted small fw-medium mb-1">Tên đơn hàng</label>
      <input
        type="text"
        class="form-control mini-input"
        [(ngModel)]="tempRename"
        maxlength="150"
        (keyup.enter)="saveRename(modal)"
        placeholder="Nhập tên đơn hàng"
        autofocus
      />
    </div>
    <div class="d-flex align-items-center gap-3">
      <button
        class="btn btn-pill-gray flex-grow-1"
        type="button"
        (click)="cancelRename(modal)"
      >
        Hủy
      </button>
      <button
        class="btn btn-pill-green flex-grow-1"
        type="button"
        [disabled]="!tempRename || !tempRename.trim()"
        (click)="saveRename(modal)"
      >
        Lưu
      </button>
    </div>
  </div>
</ng-template>

<!-- ========================================================================= -->
<!-- DELETE CONFIRMATION MINI MODAL (Screen 4 in Figma)                        -->
<!-- ========================================================================= -->
<ng-template #deleteConfirmModalTpl let-modal>
  <div class="order-template-mini-card text-center p-4">
    <div class="delete-icon-circle mx-auto mb-3">
      <i class="ri-delete-bin-line"></i>
    </div>
    <h5 class="mini-modal-title fw-bold mb-2">Xóa đơn hàng thường xuyên?</h5>
    <p class="mini-modal-desc text-muted small mb-4 px-2">
      Bạn có chắc muốn xóa đơn hàng thường xuyên này? Hành động này sẽ không thể hoàn tác
    </p>
    <div class="d-flex align-items-center gap-3">
      <button
        class="btn btn-pill-gray flex-grow-1"
        type="button"
        (click)="cancelDelete(modal)"
      >
        Hủy
      </button>
      <button
        class="btn btn-pill-red flex-grow-1"
        type="button"
        [disabled]="isDeleting"
        (click)="confirmDelete(modal)"
      >
        <span *ngIf="isDeleting" class="spinner-border spinner-border-sm me-1"></span>
        Xóa
      </button>
    </div>
  </div>
</ng-template>

<!-- ========================================================================= -->
<!-- MODAL TẠO ĐƠN HÀNG THƯỜNG XUYÊN MỚI                                      -->
<!-- ========================================================================= -->
<ng-template #createModal let-modal>
  <div class="order-template-create-card">
    <div class="modal-header-section d-flex align-items-center justify-content-between p-3 border-bottom">
      <div class="d-flex align-items-center gap-2">
        <div class="create-header-icon-circle">
          <i class="ri-add-circle-line fs-5 text-theme"></i>
        </div>
        <div>
          <h5 class="modal-header-title fw-bold m-0">Tạo đơn hàng thường xuyên mới</h5>
          <small class="text-muted">Tìm kiếm & thêm các sản phẩm thường xuyên đặt mua</small>
        </div>
      </div>
      <button class="btn-icon-close" type="button" (click)="closeCreateModal()">
        <i class="ri-close-line"></i>
      </button>
    </div>

    <div class="modal-body-section p-3 p-md-4">
      <!-- Input Name -->
      <div class="form-group mb-3">
        <label class="form-label fw-semibold text-dark mb-1">
          Tên đơn hàng thường xuyên
        </label>
        <input
          type="text"
          class="form-control create-input-name"
          placeholder="Ví dụ: Đơn thuốc định kỳ hàng tháng, Đơn vitamin & thực phẩm chức năng..."
          [(ngModel)]="createTemplateName"
          maxlength="150"
        />
        <small class="text-muted mt-1 d-block">
          Để trống nếu muốn hệ thống tự đặt tên theo ngày tạo.
        </small>
      </div>

      <!-- Product Search Section -->
      <div class="create-search-section mb-3">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <label class="form-label fw-semibold text-dark m-0">
            Tìm kiếm & thêm sản phẩm
          </label>

          <!-- Quick import triggers -->
          <div class="d-flex align-items-center gap-2">
            <button
              class="btn btn-sm btn-quick-import"
              type="button"
              title="Lấy tất cả sản phẩm đang có trong giỏ hàng"
              (click)="importFromCart()"
            >
              <i class="ri-shopping-cart-2-line me-1 text-theme"></i> Lấy từ giỏ hàng
            </button>
            <button
              class="btn btn-sm btn-quick-import"
              type="button"
              title="Lấy sản phẩm từ một đơn hàng đã đặt trước đây"
              (click)="toggleOrderImport()"
            >
              <i class="ri-history-line me-1 text-theme"></i> Lấy từ đơn cũ
            </button>
          </div>
        </div>

        <!-- Optional Order Picker dropdown when user clicks "Lấy từ đơn cũ" -->
        <div *ngIf="showOrderImportSelect" class="order-import-picker p-3 mb-3 border rounded-3 bg-light">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <span class="small fw-semibold text-dark">Chọn đơn hàng trước đây để nhập sản phẩm:</span>
            <button class="btn-close-picker" type="button" (click)="showOrderImportSelect = false">
              <i class="ri-close-line"></i>
            </button>
          </div>
          <div *ngIf="loadingOrders" class="text-muted small py-2">
            <span class="spinner-border spinner-border-sm me-2"></span> Đang tải danh sách đơn hàng...
          </div>
          <div *ngIf="!loadingOrders" class="d-flex gap-2">
            <select class="form-select form-select-sm flex-grow-1" [(ngModel)]="selectedOrderId">
              <option value="" disabled>-- Chọn đơn hàng --</option>
              <option *ngFor="let o of userOrders" [value]="o.orderId">
                Đơn #{{ o.orderId }} - {{ o.orderDate | date: 'dd/MM/yyyy' }} ({{ o.items?.length || 0 }} SP)
              </option>
            </select>
            <button
              class="btn btn-sm btn-pill-green px-3"
              type="button"
              [disabled]="!selectedOrderId"
              (click)="importFromSelectedOrder()"
            >
              Nhập SP
            </button>
          </div>
          <small *ngIf="!loadingOrders && userOrders.length === 0" class="text-danger d-block mt-1">
            Bạn chưa có đơn hàng nào trước đây.
          </small>
        </div>

        <!-- Search Bar Input -->
        <div class="create-search-bar-wrapper position-relative">
          <div class="create-search-bar position-relative">
            <i class="ri-search-line search-icon position-absolute"></i>
            <input
              type="text"
              class="form-control create-search-input"
              placeholder="Nhập tên thuốc, hoạt chất hoặc mã SKU để tìm kiếm..."
              [(ngModel)]="productSearchTerm"
              (input)="onProductSearchInput()"
              (keyup.enter)="performProductSearch(productSearchTerm)"
            />
            <button
              *ngIf="productSearchTerm"
              type="button"
              class="btn-clear-search position-absolute"
              (click)="clearProductSearch()"
            >
              <i class="ri-close-circle-fill"></i>
            </button>
            <span
              *ngIf="isSearchingProducts"
              class="search-spinner position-absolute spinner-border spinner-border-sm text-theme"
            ></span>
          </div>

          <!-- Live Search Results Dropdown/Box (absolute, nổi lên trên content) -->
          <div
            *ngIf="productSearchResults.length > 0 || (hasSearchedProducts && !isSearchingProducts && productSearchResults.length === 0 && productSearchTerm)"
            class="create-search-results-box border rounded-3 mt-1 shadow"
          >
            <!-- Empty Results State -->
            <div
              *ngIf="productSearchResults.length === 0 && hasSearchedProducts && !isSearchingProducts"
              class="p-3 text-center text-muted small"
            >
              <i class="ri-information-line fs-5 d-block mb-1 text-secondary"></i>
              Không tìm thấy sản phẩm phù hợp với từ khóa <strong>"{{ productSearchTerm }}"</strong>.
            </div>

            <!-- Result Items -->
            <div
              *ngFor="let prod of productSearchResults"
              class="search-result-row d-flex align-items-center justify-content-between p-2 border-bottom"
            >
              <div class="d-flex align-items-center flex-grow-1 me-2 overflow-hidden">
                <img
                  [src]="(prod.imageUrls && prod.imageUrls.length > 0 ? prod.imageUrls[0] : prod.imageUrl) || 'assets/images/placeholder.png'"
                  [alt]="prod.name"
                  class="result-thumb me-2 rounded flex-shrink-0"
                  (error)="prod.imageUrl = 'assets/images/placeholder.png'"
                />
                <div class="result-info overflow-hidden">
                  <div class="result-name fw-medium text-dark text-truncate" [title]="prod.name">
                    {{ prod.name }}
                  </div>
                  <div class="result-meta small text-muted d-flex align-items-center gap-2">
                    <span *ngIf="prod.sku || prod.SKU">SKU: {{ prod.sku || prod.SKU }}</span>
                    <span *ngIf="prod.packagingSpecifications || prod.unit" class="text-secondary">
                      • {{ prod.packagingSpecifications || prod.unit }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="result-actions d-flex align-items-center gap-2 flex-shrink-0">
                <div class="result-price fw-bold text-danger small">
                  {{ (prod.pricingTablePrice || prod.basePrice || 0) | currencySymbol }}
                </div>
                <button
                  class="btn btn-sm btn-add-product"
                  [class.btn-added]="isProductAdded(prod.sku || prod.SKU)"
                  type="button"
                  (click)="addCreateProduct(prod)"
                >
                  <i
                    [class]="isProductAdded(prod.sku || prod.SKU) ? 'ri-check-line' : 'ri-add-line'"
                    class="me-1"
                  ></i>
                  {{ isProductAdded(prod.sku || prod.SKU) ? ('Đã thêm (' + getProductAddedQty(prod.sku || prod.SKU) + ')') : 'Thêm' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Selected Products List Section -->
      <div class="selected-products-section mt-4">
        <div class="d-flex align-items-center justify-content-between mb-2">
          <div class="fw-semibold text-dark d-flex align-items-center gap-2">
            <span>Sản phẩm trong đơn hàng</span>
            <span class="badge bg-theme-light text-theme rounded-pill px-2">
              {{ selectedCreateItems.length }}
            </span>
          </div>

          <button
            *ngIf="selectedCreateItems.length > 0"
            class="btn-clear-all text-danger small border-0 bg-transparent p-0 cursor-pointer"
            type="button"
            (click)="clearAllCreateItems()"
          >
            <i class="ri-delete-bin-line me-1"></i> Xóa tất cả
          </button>
        </div>

        <!-- Empty Selected State -->
        <div
          *ngIf="selectedCreateItems.length === 0"
          class="empty-selected-box text-center p-4 border rounded-3 bg-light"
        >
          <div class="empty-icon-circle mx-auto mb-2">
            <i class="ri-shopping-basket-line fs-3 text-muted"></i>
          </div>
          <div class="fw-semibold text-dark mb-1">Chưa có sản phẩm nào được chọn</div>
          <div class="text-muted small">
            Nhập tên hoặc mã SKU vào ô tìm kiếm ở trên để thêm sản phẩm vào đơn hàng thường xuyên.
          </div>
        </div>

        <!-- Selected Items Scrollable List -->
        <div
          *ngIf="selectedCreateItems.length > 0"
          class="selected-items-scroll custom-scrollbar border rounded-3"
        >
          <div
            *ngFor="let item of selectedCreateItems; let idx = index"
            class="selected-item-row d-flex align-items-center p-2 p-md-3 border-bottom bg-white"
          >
            <!-- Index -->
            <div class="selected-idx text-muted small me-2 flex-shrink-0 text-center" style="width: 22px;">
              {{ idx + 1 }}
            </div>

            <!-- Thumbnail -->
            <div class="selected-img me-3 flex-shrink-0">
              <img
                [src]="item.imageUrl || 'assets/images/placeholder.png'"
                [alt]="item.name"
                class="rounded item-thumb-img"
                (error)="item.imageUrl = 'assets/images/placeholder.png'"
              />
            </div>

            <!-- Name & Price info -->
            <div class="selected-info flex-grow-1 me-2 overflow-hidden">
              <div class="item-name fw-medium text-dark text-truncate mb-1" [title]="item.name">
                {{ item.name }}
              </div>
              <div class="small text-muted d-flex align-items-center gap-2">
                <span>SKU: {{ item.sku }}</span>
                <span *ngIf="item.packaging" class="text-secondary">• {{ item.packaging }}</span>
              </div>
              <div class="item-price fw-bold text-danger small mt-1">
                {{ item.price | currencySymbol }}
              </div>
            </div>

            <!-- Stepper Quantity & Subtotal & Remove -->
            <div class="selected-actions d-flex align-items-center gap-2 flex-shrink-0">
              <!-- Stepper -->
              <div class="qty-stepper d-flex align-items-center">
                <button
                  class="btn-stepper btn-minus"
                  type="button"
                  [disabled]="item.quantity <= 1"
                  (click)="changeCreateQty(item, -1)"
                >
                  -
                </button>
                <input
                  type="number"
                  class="stepper-input"
                  [(ngModel)]="item.quantity"
                  (change)="validateCreateQty(item)"
                  min="1"
                />
                <button
                  class="btn-stepper btn-plus"
                  type="button"
                  (click)="changeCreateQty(item, 1)"
                >
                  +
                </button>
              </div>

              <!-- Trash button -->
              <button
                class="btn-trash-item"
                type="button"
                title="Xóa khỏi đơn hàng"
                (click)="removeCreateItem(item)"
              >
                <i class="ri-delete-bin-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer-section p-3 border-top bg-white">
      <div class="d-flex align-items-center justify-content-between mb-3" *ngIf="selectedCreateItems.length > 0">
        <div class="small text-muted">
          Tổng cộng: <strong>{{ selectedCreateItems.length }}</strong> sản phẩm (<strong>{{ getCreateItemsTotalQuantity() }}</strong> món)
        </div>
        <div class="d-flex align-items-center gap-2">
          <span class="small fw-medium text-dark">Tạm tính:</span>
          <span class="fw-bold text-danger fs-6">
            {{ getCreateItemsEstimatedTotal() | currencySymbol }}
          </span>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2">
        <button class="btn btn-pill-gray px-4" type="button" (click)="closeCreateModal()">
          Hủy bỏ
        </button>
        <button
          class="btn btn-pill-green px-4"
          type="button"
          [disabled]="isSubmittingCreate || selectedCreateItems.length === 0"
          (click)="submitCreate()"
        >
          <span *ngIf="isSubmittingCreate" class="spinner-border spinner-border-sm me-1"></span>
          Tạo đơn hàng thường xuyên
        </button>
      </div>
    </div>
  </div>
</ng-template>
